const pgDataLayerQuery = (preview) => `{
  pgDataLayerCollection(limit: 10, preview: ${preview}) {
    items {
      environment
      pgdl
    }
  }
}`;

module.exports = pgDataLayerQuery;
